import React from 'react'
import { Link } from 'gatsby'

const Header = (props) => {
  const { activeLink } = props;
  let eventsPage = false;
  if (typeof document !== `undefined`) {
    const url = document.location.href;
    url.indexOf('events') >= 0
      ? eventsPage = true
      : eventsPage = false;
  }

  return (
    <header className="header">
      <nav>
        <Link
          className={activeLink === 'about' ? 'nav-link' : 'nav-link'}
          to="#about"
        >
          About Carter
        </Link>
        <Link
          className={activeLink === 'omg' ? 'nav-link' : 'nav-link'}
          to="#omg"
        >
          Founding Omg
        </Link>
        <Link
          className={activeLink === 'featured' ? 'nav-link' : 'nav-link'}
          to="#featured"
        >
          Featured Events
        </Link>
        <Link
          className={activeLink === 'contact' ? 'nav-link' : 'nav-link'}
          to="#contact"
        >
          Contact
        </Link>
        <Link
          className="nav-link"
          activeClassName="active"
          to="/events/">
          Full Events List
        </Link>
      </nav>
    </header>
  )
}

export default Header
